import { render, staticRenderFns } from "./ADTable.vue?vue&type=template&id=1a1713a4&scoped=true"
import script from "./ADTable.vue?vue&type=script&lang=js"
export * from "./ADTable.vue?vue&type=script&lang=js"
import style0 from "./ADTable.vue?vue&type=style&index=0&id=1a1713a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1713a4",
  null
  
)

export default component.exports